import React, { useEffect, useState } from "react";
import {
  updateUSAEmployeeJson,
  usaEmployeeSlice,
} from "../../store/reducers/usaEmployeeSlice";
import { useSelector, useDispatch } from "react-redux";
import UsaProfessionalDetails from "./usaProfessionalDetails";
import UsaPersonalDetails from "./usaPersonalDetails";
import UsaBankDetails from "./usaBankDetails";
import UsaDocuments from "./usaDocuments";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { toast } from "react-toastify";
import { getToken } from "../../services/Token";
import jwtDecode from "jwt-decode";
import usaPayload from "./usaPayload.json";
import { genericHeaders, serviceUrl } from "../../utils/apiConfig";
import axios from "axios";
import Experience from "./usaExperience";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyCreateProfileQuery, useLazyFetchEmployeeDetailsQuery } from "../../api/profileApi";
import Loader from "../../Components/customComponents/customLoader";
import { setIsViewedEmployee } from "../../store/reducers/addEmployeeSlice";
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";

const numberOrNull = (value) =>
  value === "" || value === null || value === undefined ? null : Number(value);

const isBlank = (value) => typeof value === "string" && value.trim() === "";

const trimStrings = (obj) =>
  Object.fromEntries(
    Object.entries(obj || {}).map(([key, value]) => [
      key,
      typeof value === "string" ? value.trim() : value,
    ]),
  );

const AddUsaEmployee = ({ isInvite }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.usaEmployee.intialUsEmployee);
  const [errorMessageState, setErrorMessageState] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [stepperNumber, setStepperumber] = useState([0, 3]);
  const [completed, setCompleted] = useState([false, false, false, false]);
  const [personalDetailsError, setPersonalDetailsError] = useState({
    email: "",
    ssn: "",
    passportNumber: "",
  });
  const { empId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [createProfile, employeeData] = useLazyCreateProfileQuery();
  const [fetchEmployeeDetails, { isSuccess: isFetchEmployeeDetailsSuccess, data: superAdminManageEmployeeData }] = useLazyFetchEmployeeDetailsQuery();
  const role = localStorage.getItem("roles");
  const feildDisabled = useSelector(
    (state) => state?.usaEmployee?.feildsDisabled,
  );
  const [professionalEmailValidation, setProfessionalEmailValidation] =
    useState(false);
  const isViewedEMployee = useSelector(
    (state) => state?.addEmployee?.isViewedEMployee,
  );
  const navigate = useNavigate();

  const [steps, setSteps] = useState([
    "PROFESSIONAL DETAILS",
    "PERSONAL DETAILS",
    "BANK DETAILS",
    "OTHER DOCUMENTS",
  ]);
  const onchange = (e, directory) => {
    let { name, value } = e.target;
    if (name === "dateofJoining" || name === "confirmationDate") {
      const dateOfJoining = value;
      const date = new Date(dateOfJoining);
      value = date.toISOString();
    }
    if (name === "isManager") {
      value = value === "true" ? true : false;
    }
    if (name === "totalExperience") {
      if (value > 0 && value !== "") {
        setErrorMessageState([false, false, false, false, false]);
        setCompleted([false, false, false, false, false]);
        setStepperumber((prev) => [prev[0], 4]);
        setSteps([
          "PROFESSIONAL DETAILS",
          "PERSONAL DETAILS",
          "BANK DETAILS",
          "EXPERIENCE",
          "OTHER DOCUMENTS",
        ]);
      } else {
        setStepperumber((prev) => [prev[0], 3]);
        setErrorMessageState([false, false, false, false]);
        setCompleted([false, false, false, false]);
        setSteps([
          "PROFESSIONAL DETAILS",
          "PERSONAL DETAILS",
          "BANK DETAILS",
          "OTHER DOCUMENTS",
        ]);
      }
    }
    dispatch(
      usaEmployeeSlice.actions.updateDetails({ name, value, directory }),
    );
  };
  const getMandatoryProfessionalDetails = () => {
    let {
      companyEmail,
      currentCompanyExperience,
      referedBy,
      totalExperience,
      probationPeriod,
      confirmationDate,
      noticePeriod,
      ...mandatory
    } = state.professionalDetails;
    return mandatory;
  };
  const getDocumentsMandatory = () => {
    const checkDocument = (doc) => {
      if (Array.isArray(doc)) {
        return doc.length > 0;
      }

      return !!doc?.uploadDate;
    };

    if (state?.immigrationDocumentsList === "f1Student") {
      const { offerLetterV1, i20Form } = state?.documents || {};

      return [checkDocument(offerLetterV1), checkDocument(i20Form)];
    } else if (state.immigrationDocumentsList === "optcpt") {
      const { opt, i20Form } = state?.documents || {};

      return [checkDocument(opt), checkDocument(i20Form)];
    } else if (state.immigrationDocumentsList === "h1b") {
      // agreementLetterV1, f1VisaDocumentsV1 and ead are optional (non-mandatory)
      const { employmentDocument } = state?.documents || {};

      return [checkDocument(employmentDocument)];
    } else if (state.immigrationDocumentsList === "other") {
      return [true];
    } else {
      return [false];
    }
  };
  const getCurrentStepperObject = () => {
    const MandatoryProfessionalDetails = getMandatoryProfessionalDetails();
    const documentsMandatory = getDocumentsMandatory();

    const personalValidation = Object.values(personalDetailsError).every(
      (value) => value === "",
    )
      ? state.personalDetails
      : { stop: "" };
    if (Number(state.professionalDetails.totalExperience) > 0) {
      switch (stepperNumber[0]) {
        case 0:
          return isInvite
            ? {
                firstName: state.professionalDetails.firstName,
                lastName: state.professionalDetails.lastName,
              }
            : MandatoryProfessionalDetails;
        case 1:
          return personalValidation;
        case 2:
          return {
            ...state.bankDetails,
            bankDocumentV1: true,
            savingsAccount: true,
            accountType: true,
          };
        case 3:
          return true;
        case 4:
          return documentsMandatory;
        default:
          return null;
      }
    } else {
      switch (stepperNumber[0]) {
        case 0:
          return isInvite
            ? {
                firstName: state.professionalDetails.firstName,
                lastName: state.professionalDetails.lastName,
              }
            : MandatoryProfessionalDetails;
        case 1:
          return personalValidation;
        case 2:
          return {
            ...state.bankDetails,
            bankDocumentV1: true,
            savingsAccount: true,
            accountType: true,
          };
        case 3:
          return documentsMandatory;
        default:
          return null;
      }
    }
  };
  useEffect(() => {
    if (empId && role !== "SUPERADMIN") {
      createProfile({ employeeId: empId });
    } else if (empId && role === "SUPERADMIN") {
      dispatch(setIsViewedEmployee(true));
      fetchEmployeeDetails({ employeeId: empId });
    }
  }, [empId]);
  useEffect(() => {
    if (employeeData?.isSuccess) {
      dispatch(usaEmployeeSlice.actions.feildsDisabled(true));
      let empData = employeeData;
      let { additionalInformation, ...restProfessionalDetails } =
        empData?.data?.professionalDetails || {};
      let { dob, email, gender } = empData?.data?.personalDetails || {};
      let { firstName, lastName, offerLetterV1, isManager } =
        empData?.data || {};
      let {
        accountNumber,
        accountType,
        bankName,
        bankDocumentV1,
        currentResidentialAddress,

        drivingLicense,
        drivingLicenseDocumentV1,

        emergencyContactAddress,
        emergencyContactName,
        emergencyContactRelation,

        passportNumber,
        passportDocumentV1,

        routingNumber,
        savingsAccount,

        ssn,
        ssnDocumentV1,

        startDate,
        immigrationDocumentsList,

        ...restDocuments
      } = empData?.data?.usDetailsInfo || {};
      const Experience = empData?.data?.workExperience || [];
      const editPayload = {
        immigrationDocumentsList: immigrationDocumentsList,
        personalDetails: {
          gender: gender,
          email: email,

          ssn: ssn,
          ssnDocumentV1: Array.isArray(ssnDocumentV1) ? ssnDocumentV1 : [],

          drivingLicense: drivingLicense,
          drivingLicenseDocumentV1: Array.isArray(drivingLicenseDocumentV1)
            ? drivingLicenseDocumentV1
            : [],

          passportNumber: passportNumber,
          passportDocumentV1: Array.isArray(passportDocumentV1)
            ? passportDocumentV1
            : [],

          dob: dob,

          emergencyContactName: emergencyContactName,
          emergencyContactRelation: emergencyContactRelation,
          emergencyContactAddress: emergencyContactAddress,
        },
        professionalDetails: {
          firstName: firstName,
          lastName: lastName,
          isManager: isManager ? true : false,
          ...restProfessionalDetails,
        },
        bankDetails: {
          bankName: bankName,
          accountNumber: accountNumber,
          accountType: accountType,
          routingNumber: routingNumber,
          startDate: startDate,
          currentResidentialAddress: currentResidentialAddress,
          savingsAccount: savingsAccount,
          bankDocumentV1: Array.isArray(bankDocumentV1) ? bankDocumentV1 : [],
        },
        workExperience: [...Experience],
        documents: {
          offerLetterV1: Array.isArray(offerLetterV1) ? offerLetterV1 : [],
          ...restDocuments,
        },
      };
      dispatch(updateUSAEmployeeJson(editPayload));
      if (editPayload.professionalDetails.totalExperience > 0) {
        setStepperumber([0, 4]);
        setErrorMessageState([false, false, false, false, false]);
        setCompleted([false, false, false, false, false]);
        renderStepperContent();
        getCurrentStepperObject();
        setSteps([
          "PROFESSIONAL DETAILS",
          "PERSONAL DETAILS",
          "BANK DETAILS",
          "EXPERIENCE",
          "OTHER DOCUMENTS",
        ]);
      }
    }
  }, [employeeData]);

  useEffect(() => {
    if (isFetchEmployeeDetailsSuccess && role === "SUPERADMIN") {
      dispatch(usaEmployeeSlice.actions.feildsDisabled(true));
      let empData = superAdminManageEmployeeData;
      let { additionalInformation, ...restProfessionalDetails } =
        empData?.data?.professionalDetails || {};
      let { dob, email, gender } = empData?.data?.personalDetails || {};
      let { firstName, lastName, offerLetterV1, isManager } = empData?.data || {};
      let {
        accountNumber,
        accountType,
        bankName,
        bankDocumentV1,
        currentResidentialAddress,
        drivingLicense,
        drivingLicenseDocumentV1,
        emergencyContactAddress,
        emergencyContactName,
        emergencyContactRelation,
        passportNumber,
        passportDocumentV1,
        routingNumber,
        savingsAccount,
        ssn,
        ssnDocumentV1,
        startDate,
        immigrationDocumentsList,
        ...restDocuments
      } = empData?.data?.usDetailsInfo || {};
      const Experience = empData?.data?.workExperience || [];
      const editPayload = {
        immigrationDocumentsList: immigrationDocumentsList,
        personalDetails: {
          gender: gender,
          email: email,
          ssn: ssn,
          ssnDocumentV1: Array.isArray(ssnDocumentV1) ? ssnDocumentV1 : [],
          drivingLicense: drivingLicense,
          drivingLicenseDocumentV1: Array.isArray(drivingLicenseDocumentV1) ? drivingLicenseDocumentV1 : [],
          passportNumber: passportNumber,
          passportDocumentV1: Array.isArray(passportDocumentV1) ? passportDocumentV1 : [],
          dob: dob,
          emergencyContactName: emergencyContactName,
          emergencyContactRelation: emergencyContactRelation,
          emergencyContactAddress: emergencyContactAddress,
        },
        professionalDetails: {
          firstName: firstName,
          lastName: lastName,
          isManager: isManager,
          ...restProfessionalDetails,
        },
        bankDetails: {
          bankName: bankName,
          accountNumber: accountNumber,
          accountType: accountType,
          routingNumber: routingNumber,
          startDate: startDate,
          currentResidentialAddress: currentResidentialAddress,
          savingsAccount: savingsAccount,
          bankDocumentV1: Array.isArray(bankDocumentV1) ? bankDocumentV1 : [],
        },
        workExperience: [...Experience],
        documents: {
          offerLetterV1: Array.isArray(offerLetterV1) ? offerLetterV1 : [],
          ...restDocuments,
        },
      };
      dispatch(updateUSAEmployeeJson(editPayload));
      if (editPayload.professionalDetails.totalExperience > 0) {
        setStepperumber([0, 4]);
        setErrorMessageState([false, false, false, false, false]);
        setCompleted([false, false, false, false, false]);
        renderStepperContent();
        getCurrentStepperObject();
        setSteps([
          "PROFESSIONAL DETAILS",
          "PERSONAL DETAILS",
          "BANK DETAILS",
          "EXPERIENCE",
          "OTHER DOCUMENTS",
        ]);
      }
    }
  }, [superAdminManageEmployeeData]);

  const setFinalPayload = async () => {
    setIsLoading(true);
    const {
      firstName,
      lastName,
      isManager,
      currentCompanyExperience,
      totalExperience,
      noticePeriod,
      probationPeriod,
      ...restProfessionalDetails
    } = trimStrings(state?.professionalDetails);
    const { offerLetterV1, ...restDocuments } = state?.documents || {};
    const { dob, email, gender, ...restPersonalDetails } = trimStrings(
      state.personalDetails,
    );

    let finalPayload = {
      ...usaPayload,
      firstName: firstName,
      lastName: lastName,
      isManager: isManager === true,
      offerLetterV1: offerLetterV1,
      workExperience: state?.workExperience || [],
      personalDetails: {
        ...usaPayload.personalDetails,
        dob: dob,
        email: email,
        gender: gender,
      },
      professionalDetails: {
        ...usaPayload.professionalDetails,
        currentCompanyExperience: numberOrNull(currentCompanyExperience),
        totalExperience: numberOrNull(totalExperience),
        noticePeriod: numberOrNull(noticePeriod),
        probationPeriod: numberOrNull(probationPeriod),
        ...restProfessionalDetails,
      },
      usDetailsInfo: {
        immigrationDocumentsList: state.immigrationDocumentsList,
        ...restPersonalDetails,
        ...trimStrings(state?.bankDetails),
        ...restDocuments,
      },
    };
    console.log(JSON.stringify(finalPayload, null, 2));
    sendUsaEmployeeData(finalPayload);
  };
  const sendUsaEmployeeData = async (finalPayload) => {
    try {
      let url = `${serviceUrl}/api/employee/create`;
      let response = await axios.post(url, finalPayload, {
        headers: genericHeaders(),
      });
      if (response.status === 201) {
        resetComponent();
      }
    } catch (err) {
      console.error(err);
      const errorMessage = err?.response?.data || "Something went wrong";
      toast.error(errorMessage);

      setIsLoading(false);
    }
  };
  const submitOnBoarding = async () => {
    setIsLoading(true);
    try {
      // Transform USA state to match the backend expected structure (usaPayload)
      const {
        firstName,
        lastName,
        isManager,
        currentCompanyExperience,
        totalExperience,
        noticePeriod,
        probationPeriod,
        ...restProfessionalDetails
      } = trimStrings(state?.professionalDetails);
      const { offerLetterV1, ...restDocuments } = state?.documents || {};
      const { dob, email, gender, ...restPersonalDetails } = trimStrings(
        state.personalDetails,
      );

      const payload = {
        ...usaPayload,
        get_id: state.get_id,
        firstName: firstName,
        lastName: lastName,
        isManager: isManager === true,
        offerLetterV1: offerLetterV1,
        workExperience: state?.workExperience || [],
        personalDetails: {
          ...usaPayload.personalDetails,
          dob: dob,
          email: email,
          gender: gender,
        },
        professionalDetails: {
          ...usaPayload.professionalDetails,
          currentCompanyExperience: numberOrNull(currentCompanyExperience),
          totalExperience: numberOrNull(totalExperience),
          noticePeriod: numberOrNull(noticePeriod),
          probationPeriod: numberOrNull(probationPeriod),
          ...restProfessionalDetails,
        },
        usDetailsInfo: {
          immigrationDocumentsList: state.immigrationDocumentsList,
          ...restPersonalDetails,
          ...trimStrings(state?.bankDetails),
          ...restDocuments,
        },
      };

      const url = `${serviceUrl}/api/sendinvitation/submit/onboardingform?employeeId=${state.get_id}`;
      const response = await axios.post(url, payload);
      if (response.status === 200) {
        setIsLoading(false);
        dispatch(usaEmployeeSlice.actions.resetState());
        toast.success("Form Submitted Successfully");
        navigate("/checkMail");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Form Submission Failed");
    }
  };

  const checkDuplicateUser = async () => {
    try {
      const url = `${serviceUrl}/api/employee/checkduplicateuser`;
      const payLoad = {
        employeeNo: state?.professionalDetails?.employeeId?.trim(),
        professionalEmailId: state?.professionalDetails?.companyEmail?.trim(),
        personalEmailId: state?.personalDetails?.email?.trim(),
      };
      const response = await axios.post(url, payLoad, {
        headers: genericHeaders(),
      });
      if (response.status === 200) {
        return true;
      }
      return false;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "Employee Number or Email already exists",
      );
      return false;
    }
  };

  const checkNextStep = async (stepperNumber) => {
    const employeeId = state.professionalDetails.employeeId;
    if (professionalEmailValidation) {
      let cloneError = [...errorMessageState];
      cloneError[stepperNumber[0]] = true;
      setErrorMessageState(cloneError);
      toast.error("Please enter Valid Email");
      return;
    } else if (employeeId?.trim().length < 3) {
      let cloneError = [...errorMessageState];
      cloneError[stepperNumber[0]] = true;
      setErrorMessageState(cloneError);
      toast.error("Employee Number Should be at least 3 Characters.");
      return;
    }
    let currentStepperObject = getCurrentStepperObject(stepperNumber[0]);
    let isallFilled;

    if (Array.isArray(currentStepperObject)) {
      // For OTHER DOCUMENTS step
      isallFilled = currentStepperObject.every((value) => value === true);
    } else {
      isallFilled = Object.values(currentStepperObject || {}).every((value) =>
        Array.isArray(value) ? value.length > 0 : !isBlank(value),
      );
    }

    if (isallFilled) {
      if (!isInvite && (stepperNumber[0] === 0 || stepperNumber[0] === 1)) {
        setIsLoading(true);
        const isUniqueUser = await checkDuplicateUser();
        setIsLoading(false);
        if (!isUniqueUser) {
          return;
        }
      }
      const temp = completed;
      temp[stepperNumber[0]] = true;
      setCompleted(temp);
      let cloneError = [...errorMessageState];
      cloneError[stepperNumber[0]] = false;
      setErrorMessageState(cloneError);
      if (stepperNumber[0] === stepperNumber[1]) {
        isInvite ? submitOnBoarding() : setFinalPayload();
      } else {
        setStepperumber((prev) => [prev[0] + 1, prev[1]]);
      }
    } else {
      let cloneError = [...errorMessageState];
      cloneError[stepperNumber[0]] = true;
      setErrorMessageState(cloneError);
      toast.error("Please fill all the Mandatory Details");
    }
  };

  const renderStepperContent = () => {
    const totalExperience = state.professionalDetails.totalExperience;
    if (Number(totalExperience) > 0) {
      switch (stepperNumber[0]) {
        case 0:
          return (
            <UsaProfessionalDetails
              emailValid={professionalEmailValidation}
              setEmailValid={setProfessionalEmailValidation}
              isfilled={errorMessageState[0]}
              onchange={onchange}
              isInvite={isInvite}
            />
          );
        case 1:
          return (
            <UsaPersonalDetails
              isfilled={errorMessageState[1]}
              setPersonalDetailsError={setPersonalDetailsError}
              personalDetailsError={personalDetailsError}
              onchange={onchange}
              isInvite={isInvite}
            />
          );
        case 2:
          return (
            <UsaBankDetails
              isfilled={errorMessageState[2]}
              onchange={onchange}
            />
          );
        case 3:
          return <Experience />;
        case 4:
          return (
            <UsaDocuments isfilled={errorMessageState[4]} onchange={onchange} />
          );
        default:
          return null;
      }
    } else {
      switch (stepperNumber[0]) {
        case 0:
          return (
            <UsaProfessionalDetails
              emailValid={professionalEmailValidation}
              setEmailValid={setProfessionalEmailValidation}
              isfilled={errorMessageState[0]}
              onchange={onchange}
              isInvite={isInvite}
            />
          );
        case 1:
          return (
            <UsaPersonalDetails
              isfilled={errorMessageState[1]}
              setPersonalDetailsError={setPersonalDetailsError}
              personalDetailsError={personalDetailsError}
              onchange={onchange}
              isInvite={isInvite}
            />
          );
        case 2:
          return (
            <UsaBankDetails
              isfilled={errorMessageState[2]}
              onchange={onchange}
            />
          );
        case 3:
          return (
            <UsaDocuments isfilled={errorMessageState[3]} onchange={onchange} />
          );
        default:
          return null;
      }
    }
  };
  const resetComponent = () => {
    setStepperumber([0, 3]);
    setErrorMessageState([false, false, false, false]);
    setCompleted([false, false, false, false]);
    toast.success("Form Submitted");
    dispatch(usaEmployeeSlice.actions.resetState());
    setIsLoading(false);
    setSteps([
      "PROFESSIONAL DETAILS",
      "PERSONAL DETAILS",
      "BANK DETAILS",
      "OTHER DOCUMENTS",
    ]);
    if (feildDisabled) {
      dispatch(usaEmployeeSlice.actions.feildsDisabled(false));
      navigate("/manage");
    }
  };
  const isFinalStep = () => {
    if (stepperNumber[0] === stepperNumber[1]) {
      return true;
    } else {
      return false;
    }
  };

  const saveEmployeeDraft = async () => {
    try {
      const reponse = await axios.put(
        `${serviceUrl}/api/onboardingform/hardsave/update`,
        state,
        { headers: genericHeaders() },
      );
    } catch (error) {
      console.error(error);
    }
  };
  // When totalExperience is pre-filled (invite flow), expand to 5 steps on mount
  useEffect(() => {
    const totalExp = state?.professionalDetails?.totalExperience;
    if (totalExp > 0 && totalExp !== "") {
      setStepperumber((prev) => [prev[0], 4]);
      setErrorMessageState([false, false, false, false, false]);
      setCompleted([false, false, false, false, false]);
      setSteps([
        "PROFESSIONAL DETAILS",
        "PERSONAL DETAILS",
        "BANK DETAILS",
        "EXPERIENCE",
        "OTHER DOCUMENTS",
      ]);
    }
  }, []);

  useEffect(() => {
    console.log(state, "usa");
    if (!isViewedEMployee && !isInvite) {
      saveEmployeeDraft();
    }
  }, [state]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const message = "Changes you made may not be saved.";
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div>
      {isLoading && <Loader />}
      <div className="mt-24 ml-10 m-10">
        {feildDisabled ? (
          <></>
        ) : (
          <div className="w-screen font-bold text-blue-400 text-xl my-5">
            {isInvite ? "Fill the Form" : "ADD EMPLOYEE"}
          </div>
        )}
        {role === "SUPERADMIN" && (
          <button
            onClick={() => navigate("/superadmin")}
            className="font-bold mb-8 ml-10 text-lg flex items-center gap-2"
          >
            <KeyboardTabIcon className="rotate-180 mt-2" />
            <span>Back</span>
          </button>
        )}
        <Stepper
          activeStep={stepperNumber[0]}
          alternativeLabel
          className="mb-10"
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {renderStepperContent()}
        <button
          disabled={stepperNumber[0] === 0 ? true : false}
          onClick={() => setStepperumber((prev) => [prev[0] - 1, prev[1]])}
          className="bg-blue-600 p-3 mx-3 rounded-md text-slate-50"
        >
          Previous
        </button>
        <button
          onClick={() => feildDisabled ? setStepperumber((prev) => [prev[0] + 1, prev[1]]) : checkNextStep(stepperNumber)}
          className={`bg-blue-600 p-3 mx-3 rounded-md text-slate-50 hover:bg-blue-700 ${isFinalStep() && feildDisabled ? "cursor-not-allowed" : "cursor-pointer "}`}
          disabled={isFinalStep() && feildDisabled ? true : false}
        >
          {isFinalStep() ? "Submit" : "Next"}
        </button>
        {/* {errorMessageState[stepperNumber] && (<span className='text-red-500'>Please fill all the Mandatory Details</span>)} */}
      </div>
    </div>
  );
};

export default AddUsaEmployee;
